import request from '@/front/shared/utils/request';

export const primaryKey = 'id';

export function remove(id, teamId) {
    return request({
        url: `/teams/${teamId}/collaboration-invitations/${id}`,
        method: 'delete',
    });
}

export function show(id) {
    return get(id);
}

export function get(id, teamId) {
    return request({
        url: `/teams/${teamId}/collaboration-invitations/${id}`,
        method: 'get',
    });
}

export function update(id, teamId, data) {
    return request({
        url: `/teams/${teamId}/collaboration-invitations/${id}`,
        method: 'put',
        data,
    });
}

export function store(teamId, data) {
    return request({
        url: `/teams/${teamId}/collaboration-invitations`,
        method: 'post',
        data,
    });
}

export function save(data) {
    if (data.hasOwnProperty(primaryKey) && data[primaryKey] != null) {
        return update(data[primaryKey], data);
    }

    return store(data);
}
